import { alpha, StyleRules } from '@material-ui/core/styles';
import { BackdropClassKey } from '@material-ui/core/Backdrop';

import { core as theme } from '../styles/core';

export const MuiBackdrop: Partial<StyleRules<BackdropClassKey>> = {
  root: {
    backgroundColor: alpha(theme.palette.common.black, 0.4),
  },
};
